/*
 * - Stores paths for the JPA service endpoints
 */

const serviceRoot = 'api/jpa/';

export const JpaEndpoints = {
  getDynamicTable: () => `${serviceRoot}getDynamicTableHeaders`,
  getDynamicTableAnswers: () => `${serviceRoot}getDynamicTableAnswers`,
  getForm: () => `${serviceRoot}getFormData`,
  getInitialSection: () => `${serviceRoot}getInitialSection`,
  getOrgs: () => `${serviceRoot}getOrgData`,
};
